export default __webpack_public_path__ + "static/media/intuitive_integration.cb943bcd.png";